module.exports = __webpack_public_path__ + "img/plan6.14d079bf.svg";